import React from "react";
import { convertThenFormat } from "../../common-data/Converts";

const CmWallet = ({ userInfoData, clusterManagerData }) => {
  const total_balance = clusterManagerData?.data?.[0]?.petty_cash;

  return (
    <div
      style={{
        background: "linear-gradient(135deg, #1E1E1E 0%, #2D2D2D 100%)",
        borderRadius: "8px",
        padding: "12px 20px",
        color: "white",
        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.3)",
        minWidth: "320px",
        marginLeft: "24px",
        display: "flex",
        alignItems: "center",
        gap: "16px",
        position: "relative",
        overflow: "hidden",
        border: "1px solid rgba(255, 255, 255, 0.1)",
      }}
    >
      {/* Decorative line */}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          height: "3px",
          background: "linear-gradient(90deg, #00E676 0%, #00C853 100%)",
        }}
      />

      {/* Icon */}
      <div
        style={{
          background: "rgba(255, 255, 255, 0.05)",
          borderRadius: "8px",
          padding: "8px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          border: "1px solid rgba(255, 255, 255, 0.1)",
        }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          fill="#00E676"
          viewBox="0 0 16 16"
        >
          <path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4zm2-1a1 1 0 0 0-1 1v1h14V4a1 1 0 0 0-1-1H2zm13 4H1v5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V7z" />
          <path d="M2 10a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-1z" />
        </svg>
      </div>

      {/* Content */}
      <div style={{ flex: 1 }}>
        <div
          style={{
            fontSize: "16px",
            fontWeight: "500",
            // marginBottom: "2px",
            color: "rgba(255, 255, 255, 0.7)",
            letterSpacing: "0.5px",
          }}
        >
          My Wallet Balance
        </div>
        <div
          style={{
            fontSize: "28px",
            fontWeight: "700",
            background: "linear-gradient(90deg, #00E676 0%, #00C853 100%)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            letterSpacing: "0.5px",
            display: "inline-block",
          }}
        >
          ₹{convertThenFormat(total_balance || 0)}
        </div>
      </div>
    </div>
  );
};

export default CmWallet;
